import { generateDTRTable } from "../tables/dtr";
import { generateSectionParagraphs } from "../utils/WordExportUtils";
import {
  defaultFontBold,
  defaultFontItalic,
  defaultFontNormal,
} from "../utils/styling";

export const getDoubleTaxReliefParagraphs = (data) => {
  const { poaData, groupName } = data;

  const taxExists = poaData?.adjusted_caps?.some((c) => {
    const reliefEqualUk = c.s407_relief_dtr_adjustment_tax_rate_equal_uk;
    const reliefNotEqualUk = c.s407_relief_dtr_adjustment_tax_rate_not_equal_uk;

    return (
      (reliefEqualUk?.value ?? reliefEqualUk) < 0 ||
      (reliefNotEqualUk?.value ?? reliefNotEqualUk) < 0
    );
  });

  const ofaExists = poaData?.adjusted_caps?.some((c) => {
    const ofaExcludeDoubleRelief =
      c.ofa_exclude_tax_interest_income_double_relief;
    return ofaExcludeDoubleRelief?.value ?? ofaExcludeDoubleRelief;
  });

  const dtrTable = taxExists ? generateDTRTable() : [];

  const paragraphs = [
    {
      condition: taxExists,
      segments: [
        {
          text: "Double Tax Relief:",
          font: defaultFontBold,
          break: 1,
        },
        {
          text: "The Corporate Interest Restriction regime excludes income, including interest income, that does not (or only partially) increases the UK tax liability due to being sheltered by double tax relief by way of credit under s18 TIOPA 2010.",
          font: defaultFontNormal,
          break: 1,
        },
        {
          text: 'Where an amount has been wholly or partially sheltered from UK corporation tax by double tax relief (DTR) then that amount is excluded from being “Tax-EBITDA” or, in respect of amounts that would otherwise be "Tax-Interest income".',
          font: defaultFontNormal,
          break: 2,
        },
        {
          text: "Mechanically, where an adjustment arises in respect of Tax-Interest income, it is necessary to make an adjustment to exclude the relevant amount from both the calculation of Tax-Interest and, as it is then not excluded from Tax-EBITDA by virtue of being Tax-Interest income, also from Tax-EBITDA. The amount of the reduction is the amount of credit divided by the rate of UK corporation tax payable on the company’s profits (i.e. the amount of the income which is ultimately not subject to UK tax by virtue of the DTR claimed).",
          font: defaultFontNormal,
          break: 2,
        },
        {
          text: "Application to the ",
          font: defaultFontItalic,
          break: 2,
        },
        {
          text: groupName,
          font: defaultFontItalic,
        },
        {
          text: " group",
          font: defaultFontItalic,
        },
        {
          text: "As the amount of corporation tax chargeable by UK group companies has been reduced by the application of double tax relief under s18 TIOPA 2010, a corresponding adjustment has been made to reduce Tax-EBITDA.",
          font: defaultFontNormal,
          break: 1,
        },
      ],
    },
    {
      condition: ofaExists,
      segments: [
        {
          text: "As the double tax relief claim is partly in respect of Tax-Interest income amounts, an adjustment has also been made in calculating Tax-Interest.",
          font: defaultFontNormal,
          break: 1,
        },
      ],
    },
    {
      condition: taxExists && dtrTable,
      segments: [
        {
          text: "The amount of the adjustments are set out below:",
          font: defaultFontNormal,
          break: 1,
        },
      ],
    },
  ];

  return [...generateSectionParagraphs(paragraphs), ...dtrTable];
};
